export default "__VITE_ASSET__BiLLncHi__"